<template>
  <!-- eslint-disable max-len -->
  <div
    class="sb_view_home"
    style="background-image: url('static/img/bg.jpg');"
  >
    <div class="sb_grid">
      <div class="sb_grid_container u_max-width-1000 u_padding-top-40 u_margin-top-40">
        <div class="sb_grid_column_3-4">
          <ContentHeader
            title="<span style='font-style: italic;'>a<sub>w</sub></span> calculator"
            class="v_description-min-height"
          >
            <template v-slot:description>
              <p>For preservation in savory application the water activity is an important hurdle. The lower the water activity, generally speaking the less outgrow of microorganisms. Also, risks of growth  of certain pathogenic microorganisms can be eliminated by adjusting the water activity. Calculating the water activity of your formulation and/or the impact on water activity if ingredients are changed, provides great insight and potentially decreases your expensive research time and the use of raw materials.  Use this tool to reduce the sodium in your recipe, without compromising on water activity.</p>

              <p>
                This tool gives a rough prediction of water activity in liquid mixtures. It should only be used for an indication as it does not do pH and solubility calculations. For more extensive calculations use Elecsis (<a
                  target="blank"
                  href="https://elecsis.corbion.com/"
                >https://elecsis.corbion.com/</a>).
              </p>
            </template>
          </ContentHeader>
          <hr>
          <RouterLink
            to="/calculator"
            class="sb_button v_has-icon-right v_icon-faded v_brand-primary-lighter v_expand-on-small u_margin-bottom-0"
            :disabled="false"
            tag="button"
          >
            <ButtonObject icon="icon_ui_caret-right">
              Get started
            </ButtonObject>
          </RouterLink>
        </div>
      </div>
    </div>
  </div>
  <!-- eslint-enable max-len -->
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';

import ContentHeader from '@/components/assemblies/content-header';
// import Loader from '@/components/objects/loader';

export default {
  name: 'Home',
  components: {
    ContentHeader
    // Loader
  },
  data() {
    return {
      showRegisterModal: false,
      email: null,
      password: null,
      loginError: null,
      loggingIn: false
    };
  },
  computed: {
    ...mapState('global', [
      'appTitle'
    ])
  },
  methods: {
    ...mapActions('auth', [
      'authenticate'
    ]),
    ...mapMutations('auth', [
      'setUser'
    ]),
    openRegisterModal() {
      this.showRegisterModal = true;
    },
    async login() {
      // this.loggingIn = true;
      // const res = await this.authenticate({
      //   email: this.email,
      //   pass: this.password
      // });
      // this.loggingIn = false;
      // if (res instanceof Array) {
      //   this.password = '';
      //   this.loginError = true;
      //   return;
      // }
      // if (res)
      this.$router.push('calculator');
    }
  }
};
</script>

<style lang="scss" scoped>
  .sb_view_home {
    @include media("<medium") {
      background-image: none !important;
    }
  }
</style>
